<template>
  <div class="d-flex justify-content-center mt-5">
    <div class="d-flex flex-row" v-if="!pedidoCancelamento">
      <p class="">Exclua sua conta e todos os seus dados</p>
      <b-link
        v-if="!pedidoCancelamento"
        :title="this.mensagemBotaoCancelamento"
        :disabled="pedidoCancelamento && this.resumoContrato.valor_total > 0"
        @click="
          modalVerificaCancelamento.abrirModalVerificaCancelamento(
            resumoContrato.id,
            '1',
            resumoContrato
          )
        "
        class="ml-1" style="text-decoration: underline;"
      >clicando aqui</b-link>
    </div>
  </div>
</template>

<script>
import CancelamentoContrato from './js/cancelamento-contrato'
export default CancelamentoContrato
</script>
